import { useQuery } from '@tanstack/react-query';
import { getAnalysisQueryKey } from '@/utilities/portfolio';

import type { Portfolio } from '@/hooks/usePortfolio';

import { queryFn } from './queryFn';

type DiversificationTree = {
  type: string;
  weight: number;
  name?: string;
  symbol?: string;
  sectors?: DiversificationTree[];
  primaryIndustries?: DiversificationTree[];
  holdings?: DiversificationTree[];
};

export interface PortfolioFragmentType {
  diversification?: DiversificationTree;
}

export const usePortfolioDiversification = (portfolioId: Portfolio['id']) => {
  const queryKey = getAnalysisQueryKey(
    portfolioId,
    'DiversificationAcrossIndustries'
  );
  return useQuery({
    queryKey,
    queryFn,
  });
};

export type PortfolioDiversification = NonNullable<
  ReturnType<typeof usePortfolioDiversification>['data']
>;
